import {
  Avatar,
  AvatarFallback,
  AvatarGroup,
  AvatarImage,
  CommentThreadRow,
  initials,
  MentionText,
} from "@hulahoop/ui";
import type { CommentThread } from "@/domain/comment";
import type { CommentsLabels } from "@/domain/types/commentsLabels";
import { commentMentionText } from "@/utils/commentMentions";

export function CommentsThreadList({
  threads,
  global,
  labels,
  relativeTime,
  onOpen,
}: {
  threads: CommentThread[];
  global: boolean;
  labels: CommentsLabels;
  relativeTime: (date: string) => string;
  onOpen: (uuid: string) => void;
}) {
  return (
    <>
      {threads.map((thread) => (
        <CommentThreadRow
          key={thread.uuid}
          avatars={
            <AvatarGroup className="shrink-0">
              {thread.participants.slice(0, 2).map((person) => (
                <Avatar key={person.uuid} className="size-5">
                  {person.avatar && <AvatarImage src={person.avatar} alt="" />}
                  <AvatarFallback>{initials(person.name)}</AvatarFallback>
                </Avatar>
              ))}
            </AvatarGroup>
          }
          author={thread.author?.name ?? labels.unknown_author}
          time={relativeTime(thread.last_message_at)}
          unread={!thread.is_read}
          resolved={!!thread.resolved_at}
          excerpt={
            <MentionText
              text={
                thread.root_message?.deleted_at
                  ? labels.deleted
                  : commentMentionText(
                      thread.root_message?.body ?? "",
                      thread.root_message?.mentions ?? [],
                    )
              }
            />
          }
          replies={thread.reply_count}
          repliesLabel={labels.replies}
          record={global ? thread.subject.label : undefined}
          onOpen={() => onOpen(thread.uuid)}
        />
      ))}
    </>
  );
}
